const COOKIE_NAME = "lapaire_country";
const MAX_AGE = 31536000; // 1 year

export function getCountryCookie(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1] ?? "") : null;
}

export function setCountryCookie(slug: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(slug)}; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
}

export function clearCountryCookie(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax`;
}
